<svelte:options
  customElement={{
    tag: "ofc-warranty-label-v1",
    shadow: "none",
    props: {
      duration: { type: "Number" },
      brand: { type: "String" },
      model: { type: "String" },
    },
  }}
/>

<script lang="ts">
  import type { Props } from "./WarrantyLabelV1.types.ts";
  import NestedLabel from "./NestedLabel.svelte";
  import LargeLabel from "./LargeLabel.svelte";

  const { duration = 0, brand = "brand", model = "model" }: Props = $props();
  let sheet = $state<HTMLOcSheetV1Element>();

  const openSheet = () => {
    if (sheet) {
      sheet.open = true;
      document.dispatchEvent(new Event("ofc-warranty-label-sheet-open"));
    }
  };
</script>

<button class="wrapper" type="button" onclick={openSheet}>
  <NestedLabel {duration} />
</button>

<oc-sheet-v1 bind:this={sheet} id="ofc-warranty-label-sheet" headline="My sheet headline">
  <LargeLabel {duration} {brand} {model} />
</oc-sheet-v1>

<style lang="scss">
  @use "@otto-ec/design-tokens/tokens";

  .wrapper {
    appearance: none;
    background: none;
    border: 1px solid tokens.$oc-base-color-black-100;
    border-radius: 1px;
    cursor: pointer;
    height: 22px;
    padding: 0;
    width: fit-content;
  }
</style>
